export class EstadoAcuerdo {

  public static Activo;
  public static Pendiente;
  public static Cancelado;

  constructor() {
    EstadoAcuerdo.Activo = 1;
    EstadoAcuerdo.Pendiente = 2;
    EstadoAcuerdo.Cancelado = 3;
  }

  get staticActivo() {
    return EstadoAcuerdo.Activo;
  }
  get staticPendiente() {
    return EstadoAcuerdo.Pendiente;
  }
  get staticCancelado() {
    return EstadoAcuerdo.Cancelado;
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/estado-acuerdo.model.ts